import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  sessionExpired: boolean;
  sessionExpiredReason: string | null;
}

const initialState: AuthState = {
  sessionExpired: false,
  sessionExpiredReason: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSessionExpired: (state, action: PayloadAction<{ expired: boolean; reason?: string }>) => {
      // Idempotent - only update if not already expired (prevents re-renders from multiple 401s)
      if (!state.sessionExpired && action.payload.expired) {
        state.sessionExpired = true;
        state.sessionExpiredReason = action.payload.reason ?? 'Your session has expired.';
      }
    },
    clearSessionExpired: (state) => {
      state.sessionExpired = false;
      state.sessionExpiredReason = null;
    },
  },
});

export const { setSessionExpired, clearSessionExpired } = authSlice.actions;
export default authSlice.reducer;
